var map = {
	"./ahituna.jpg": 103,
	"./crabstick.jpg": 104,
	"./eel.jpg": 105,
	"./octopus.jpg": 106,
	"./salmon.jpg": 107,
	"./shrimp.jpg": 108,
	"./spicycrabmeat.jpg": 109,
	"./spicyoctopus.jpg": 110,
	"./spicyrealcrabmeat.jpg": 111,
	"./spicysalmon.jpg": 112,
	"./spicyshrimp.jpg": 113,
	"./spicytuna.jpg": 114,
	"./spicyyellowtail.jpg": 115,
	"./yellowtail.jpg": 116
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 102;


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein ^\.\/.*$
// module id = 102
// module chunks = 0